export default __webpack_public_path__ + "static/media/logo.655b97b6.png";